import {
    createVimeoHandler,
    createYouTubeHandler,
    createReachVideoHandler,
} from '../../../../MediaController';
import { GlobalVideoHandlerInterface, VideoHandlerOptions } from '../Interface/Unstable/Video';

export function createVideoHandler(
    type: 'reach' | 'vimeo' | 'youtube',
    videoId: string,
    options?: VideoHandlerOptions
): GlobalVideoHandlerInterface {
    options = options || {};

    switch (type) {
        case 'reach':
            return createReachVideoHandler({
                muted: options.muted,
                startTime: options.startTime,
                videoUuid: videoId,
                bsViewModeScaleToFill: options.bsViewModeScaleToFill,
            });
        case 'vimeo':
            return createVimeoHandler({
                muted: options.muted,
                startTime: options.startTime,
                vimeoVideoId: parseInt(videoId, 10),
                showSubtitles: options.showSubtitles,
            });
        case 'youtube':
            return createYouTubeHandler({
                muted: options.muted,
                startTime: options.startTime,
                youtubeLink: videoId,
                youtubePlaybackQuality: options.youtubePlaybackQuality,
                showSubtitles: options.showSubtitles,
            });
        default:
            throw new Error('Illegal video type');
    }
}
